import React from 'react'
import { NavLink } from 'react-router-dom';

import './CardHomeOut.css'

function CardHomeOut({ title, text, img, lineColor }) {
  return (
    <div className="bienvenido__card">
        <div className=''>
            <div className="cardBienvenido__title">
                <img src={img} className={`imgbienvenido ${lineColor}`} alt="coursera" />
            </div>
            <div className="cardBienvenido__textos">
                <div className="cardBienvenido__texttitle text-center text-md-start mt-3 mb-2 px-4">{title}</div>
                <div className="cardBienvenido__textdetalle text-center text-md-start px-4">{text}</div>
            </div>
        </div>
            <div className="d-flex d-md-none">
                <NavLink to={"/registro"} className={'btnCardHomeOut fontCIBFont col-7 mx-auto text-center text-decoration-none py-1 mb-4 rounded-pill'} >Ver más</NavLink>
            </div>
            <div className="d-none d-md-flex">
                <NavLink to={"/registro"} className={'ms-4 mb-3 fontCIBFont text-left text-black text-decoration-none fw-bold'} >Ver más</NavLink>
            </div>
    </div>
  )
}

export default CardHomeOut;